import { ModuleCodes } from '../../../../models/modules';
import { WebSocketsReservationEvents, WebSocketsTripEvents } from '../../../../models/web-sockets';

const mServerTable = {
  footer: {
    selectAll: 'Selecionar Tudo',
    allPageSelected: {
      text: 'Todos os {{number}} itens nesta página estão selecionados.',
      action: 'Selecionar todos os {{number}} itens',
    },
    allPagesSelected: {
      text: 'Todos os itens {{number}} na tabela estão selecionados.',
      action: 'Limpar seleção',
    },
  },
  noResults: 'Sem resultados',
  total: 'Total',
  generalSearch: 'Buscar',
  actions: {
    more: 'Mais',
    clearFilters: 'Limpar filtros',
    hiddenColumns: 'Colunas ocultas',
    refreshTable: 'Atualizar Tabela',
  },
  floatingActions: {
    extraActionsMenu: {
      button: 'Mais',
      title: 'Mais ações',
    },
    selectedText: {
      single: 'Item selecionado',
      many: 'Itens selecionados',
    },
  },
  updates: {
    [ModuleCodes.Trips]: {
      [WebSocketsTripEvents.New]: 'Novo',
      [WebSocketsTripEvents.Update]: 'Atualizar',
      [WebSocketsTripEvents.Cancel]: 'Cancelamento',
      [WebSocketsTripEvents.StatusChange]: 'Mudança de estado',
    },
    [ModuleCodes.Reservations]: {
      [WebSocketsReservationEvents.New]: 'Novo',
      [WebSocketsReservationEvents.Update]: 'Atualizar',
      [WebSocketsReservationEvents.Cancel]: 'Cancelamento',
      [WebSocketsReservationEvents.StatusChange]: 'Mudança de estado',
    },
  },
};

export default mServerTable;
